<template>
  <div>
    <div v-show="companyLives.length" class="gutter-b">
      <div class="row">
        <div
          v-for="live in companyLives"
          :key="live.id"
          class="col-md-4 gutter-b"
        >
          <div class="card h-100">
            <div class="card-header py-2">
              <router-link
                :to="{
                  name: 'admin-programs-show',
                  params: { id: live.program_id }
                }"
              >
                {{ live.program.name }}
              </router-link>
            </div>
            <div class="card-body p-0">
              <router-link
                :to="{
                  name: 'admin-lives-show',
                  params: {
                    program: live.program_id,
                    live: live.id
                  }
                }"
              >
                <LiveImage :live="live"></LiveImage>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div
        class="overflow-auto mt-5"
        v-if="companyLivesPagination.lastPage > 1"
      >
        <b-pagination
          v-model="companyLivesPagination.currentPage"
          :total-rows="companyLivesPagination.total"
          :per-page="companyLivesPagination.perPage"
          aria-controls="my-table"
          @input="getLives()"
        ></b-pagination>
      </div>
    </div>
    <div v-if="companyLives.length === 0">
      <div class="alert alert-primary" role="alert">پخش فعالی یافت نشد.</div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { mapGetters } from "vuex";
import { FETCH_COMPANY_LIVES } from "@/core/services/store/company/lives.module";
import LiveImage from "@/view/content/widgets/LiveImage";

export default {
  name: "company-dashboard",
  components: {
    LiveImage
  },
  data() {
    return {
      interval: null,
      livesLoaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.currentUserProperty.title ?? "داشبورد شرکت",
        route: { name: "company-dashboard" }
      },
      { title: "پخش های فعال" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});
    this.getLives();
    this.interval = setInterval(this.getLives, 30000);
  },
  destroyed() {
    clearInterval(this.interval);
    this.interval = null;
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "companyLives",
      "companyLivesPagination"
    ])
  },
  methods: {
    getLives(first = false) {
      this.livesLoaded = false;
      if (first) {
        this.$store.state.companyLives.companyLivesPagination.currentPage = 1;
      }

      this.$store
        .dispatch(FETCH_COMPANY_LIVES, {
          status: 0
        })
        .then(() => {
          this.livesLoaded = true;
        })
        .catch(() => {
          this.livesLoaded = true;
        });
    }
  }
};
</script>
